import {
  HeaderMobilStyled,
  HeaderStyled,
  NewHeaderStyled,
} from "../Styles/Header";
import LogoP from "../Assets/Logos/logoBranca_BRK.svg";
import { FaUserGear, FaUser, FaUserPen } from "react-icons/fa6";
import { IoExit } from "react-icons/io5";
import { HomeContext } from "../Context/ContextHome";
import { useContext, useState } from "react";
import { TbArrowBackUp } from "react-icons/tb";
import { IoMenu, IoHome, IoClose } from "react-icons/io5";
import { ModalEditarSenha } from "../Pages/admin/modals";
import { useLocation } from "react-router-dom";
import { RxDashboard } from "react-icons/rx";
import { LiaProjectDiagramSolid } from "react-icons/lia";
import { FaBell } from "react-icons/fa";

export const Header = ({ pgAdmin, pgRedireciona }) => {
  const { navigate, infoUser, modalEditarSenha, setModalEditarSenha } =
    useContext(HomeContext);

  return (
    <HeaderStyled>
      {modalEditarSenha && <ModalEditarSenha />}
      <div className="logo" onClick={() => navigate("/")}>
        <img src={LogoP} alt="Logo" />
      </div>

      <div className="titulo">
        <h1>Sistema de Gerenciamento</h1>
      </div>

      <nav>
        <ul>
          {pgAdmin ? (
            infoUser.role === "3" || infoUser.role === "4" ? (
              <li
                className="menu"
                onClick={() => {
                  navigate("/admin");
                }}
                title="Usuario Admin"
              >
                <p>{infoUser.nome}</p>
                <FaUserGear className="iconesUser" />
              </li>
            ) : (
              <li className="menuUser">
                <p>{infoUser.nome}</p>
                <FaUser className="icones" />

                <ul className="submenu">
                  <li
                    onClick={() => {
                      setModalEditarSenha(true);
                    }}
                  >
                    <p>Editar Usuário</p>
                  </li>
                </ul>
              </li>
            )
          ) : (
            <li
              className="menu"
              onClick={() => {
                navigate(pgRedireciona);
              }}
            >
              <p>{infoUser.nome}</p>
              <TbArrowBackUp className="icones" />
            </li>
          )}

          <li
            className="menu"
            onClick={() => {
              localStorage.removeItem("tokenBrk");
              navigate("/login");
            }}
          >
            Sair <IoExit className="icones sairIcon " />
          </li>
        </ul>
      </nav>
    </HeaderStyled>
  );
};

export const HeaderMobil = ({ pgAdmin, pgRedireciona }) => {
  const { navigate, infoUser } = useContext(HomeContext);
  const [menuOn, setMenuOn] = useState(false);

  return (
    <HeaderMobilStyled>
      <div className="menu" onClick={() => setMenuOn(!menuOn)}>
        {menuOn ? <IoClose /> : <IoMenu />}
      </div>
      <div className="titulo">
        <h1>Sistema de Gerenciamento</h1>
      </div>
      {menuOn && (
        <nav className="menuNav">
          <div className="logo" onClick={() => navigate("/")}>
            <img src={LogoP} alt="Logo" />
          </div>
          <ul>
            <li
              className="menu"
              onClick={() => {
                navigate("/");
              }}
            >
              <IoHome />
            </li>
            {pgAdmin ? (
              infoUser.role === "3" ||
              (infoUser.role === "4" && (
                <li
                  className="menu"
                  onClick={() => {
                    navigate("/admin");
                  }}
                >
                  <FaUserGear className="icones" />
                </li>
              ))
            ) : (
              <li
                className="menu"
                onClick={() => {
                  navigate(pgRedireciona);
                }}
              >
                <TbArrowBackUp className="icones" />
              </li>
            )}

            <li
              className="menu"
              onClick={() => {
                if (
                  window.ReactNativeWebView &&
                  window.ReactNativeWebView.postMessage
                ) {
                  window.ReactNativeWebView.postMessage(
                    JSON.stringify({ type: "route", path: "Exit" })
                  );
                }
                navigate("/login");
                localStorage.removeItem("tokenBrk");
              }}
            >
              <IoExit className="icones sairIcon" />
            </li>
          </ul>
        </nav>
      )}
    </HeaderMobilStyled>
  );
};

export const NewHeader = () => {
  const {
    navigate,
    infoUser,
    modalEditarSenha,
    setModalEditarSenha,
    darkMode,
    setModalDiagrama,
    modalDiagrama,
    alerEmergenciaList,
    setModalAvisosEmegencia,
  } = useContext(HomeContext);

  const location = useLocation();
  return (
    <NewHeaderStyled darkMode={darkMode}>
      {modalEditarSenha && <ModalEditarSenha />}
      <div className="logo" onClick={() => navigate("/")}>
        <img src={LogoP} alt="Logo" />
      </div>
      <nav className="selecMode">
        <div
          className={`mode ${!modalDiagrama ? "active" : ""}`}
          onClick={() => {
            if (location.pathname === "/") {
              localStorage.setItem("HomeMode", false);
              setModalDiagrama(false);
            } else {
              navigate("/");
              localStorage.setItem("HomeMode", false);
              setModalDiagrama(false);
            }
          }}
        >
          <RxDashboard />
        </div>
        <div
          className={`mode ${!modalDiagrama ? "" : "active"}`}
          onClick={() => {
            if (location.pathname === "/") {
              localStorage.setItem("HomeMode", true);
              setModalDiagrama(true);
            } else {
              navigate("/");
              localStorage.setItem("HomeMode", true);
              setModalDiagrama(true);
            }
          }}
        >
          <LiaProjectDiagramSolid />
        </div>
        <div className="alertas" onClick={() => setModalAvisosEmegencia(true)}>
          {/* <span>{alerEmergenciaList.length}</span> */}
          <FaBell className="icone" />
        </div>
      </nav>
      <ul className="ulExite">
        {infoUser.role === "3" || infoUser.role === "4" ? (
          <li
            className="menu"
            onClick={() => {
              navigate("/admin");
            }}
            title="Usuario Admin"
          >
            <FaUserGear className="iconesUser" />
            <span className="labelNav">
              <span>Admin</span>
              <p>{infoUser.nome}</p>
            </span>
          </li>
        ) : (
          <li
            className="menu"
            onClick={() => {
              setModalEditarSenha(true);
              console.log("Clicou para editar senha");
            }}
          >
            <FaUserPen className="icones" />
            <span className="labelNav">
              <span>Editar Usuário</span>
              <p>{infoUser.nome}</p>
            </span>
          </li>
        )}
        <li
          className="menu"
          onClick={() => {
            if (
              window.ReactNativeWebView &&
              window.ReactNativeWebView.postMessage
            ) {
              window.ReactNativeWebView.postMessage(JSON.stringify("Home"));
            }
            navigate("/login");
            localStorage.removeItem("tokenSAE");
          }}
        >
          <IoExit className="icones sairIcon" />
          <span className="labelNav">
            <span>Sair</span>
          </span>
        </li>
      </ul>
    </NewHeaderStyled>
  );
};
